module.exports = __webpack_public_path__ + "img/2019.ea8d7ba5.png";